import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Assessment 2",
    duration: 15
};

export const module2Questions: QuizQuestion[] = [
    {
        id: "M2-001",
        moduleId: "module-2",
        category: "Controls",
        text: "The 'Primary Controls' of a vehicle include the steering wheel, accelerator, and ____.",
        options: ["Radio", "Service Brake", "Turn Signal", "Windshield Wipers"],
        correctAnswer: 1,
        scenario: "The three primary vehicle controls are the **steering wheel**, the **accelerator**, and the **service brake pedal**. Together, these three controls allow the pilot to change the vehicle's speed, direction, and stopping force to navigate the highway transportation system safely.",
        explanation: ""
    },
    {
        id: "M2-002",
        moduleId: "module-2",
        category: "Awareness",
        text: "How much information does a driver receive through their eyes?",
        options: ["50%", "75%", "Over 90%", "10%"],
        correctAnswer: 2,
        scenario: "Over **90% of all information** you receive while driving is visual. Because safe driving is almost entirely dependent on your eyes, maintaining a clean windshield, aligning your mirrors properly, and keeping your eyes moving are your most critical habits.",
        explanation: ""
    },
    {
        id: "M2-003",
        moduleId: "module-2",
        category: "Awareness",
        text: "Peripheral vision is used primarily to detect ____.",
        options: ["Color", "Motion and light", "Sharp detail", "Speedometer readings"],
        correctAnswer: 1,
        scenario: "Your peripheral (outer) vision is extremely sensitive to **motion and light**. While it cannot see sharp details, it alerts you to approaching hazards from the sides—such as a vehicle merging, a pedestrian stepping off a curb, or flashing emergency lights—prompting you to turn your head and focus your central vision.",
        explanation: ""
    },
    {
        id: "M2-004",
        moduleId: "module-2",
        category: "Controls",
        text: "The 'Hazard Flasher' should be used when ____.",
        options: ["Driving in heavy rain", "The vehicle is a hazard to other drivers", "You are double-parked", "You are in a hurry"],
        correctAnswer: 1,
        scenario: "You must activate your hazard warning lights (the red double-triangle button) whenever **your vehicle becomes a hazard to other drivers** on the road. Examples include being stalled on the highway, driving at extremely slow speeds due to mechanical issues, or pulling over onto the shoulder to change a flat tire. *Note:* Ohio law prohibits using hazards while driving normally, even in heavy rain.",
        explanation: ""
    },
    {
        id: "M2-005",
        moduleId: "module-2",
        category: "Maintenance",
        text: "A red warning light on the dashboard usually means ____.",
        options: ["A minor problem", "An immediate safety risk/system failure", "The system is working properly", "Low fuel only"],
        correctAnswer: 1,
        scenario: "A red warning light indicates an **immediate safety risk or critical system failure**. Safe pilots must execute the 'Red Protocol': pull over safely to a secure location as soon as possible and turn off the engine immediately. Continuing to drive with a red warning light risks catastrophic mechanical failure or a major crash.",
        explanation: ""
    },
    {
        id: "M2-006",
        moduleId: "module-2",
        category: "Awareness",
        text: "Blind spots are areas around the vehicle that ____.",
        options: ["Are only behind the car", "Cannot be seen in mirrors", "Are blocked by the engine", "Only exist for trucks"],
        correctAnswer: 1,
        scenario: "Mirror blind spots are the large ground-level zones around the sides and rear of your vehicle that **cannot be seen in standard rearview or side mirrors**. The Blind Spot and Glare Elimination (BGE) method eliminates these zones by adjusting the side mirrors outward by approximately 15 degrees. This widens your field of vision, overlaps your side and rearview fields of view, and ensures that other vehicles transition smoothly from your mirrors directly into your peripheral vision without disappearing.",
        explanation: ""
    },
    {
        id: "M2-007",
        moduleId: "module-2",
        category: "Controls",
        text: "The 'dead pedal' is used for ____.",
        options: ["Emergency braking", "Bracing the driver's left foot", "Starting the car", "Clutch control"],
        correctAnswer: 1,
        scenario: "The dead pedal is a solid, non-functional footrest designed to **brace the driver's left foot** during driving. This bracing helps keep the driver securely positioned in their seat during turns, supports correct posture, and ensures the right foot remains at the proper angle for precise accelerator and brake control.",
        explanation: ""
    },
    {
        id: "M2-008",
        moduleId: "module-2",
        category: "Security",
        text: "When approaching your vehicle at night, you should have your ____ in hand.",
        options: ["Phone", "Keys", "Flashlight", "Wallet"],
        correctAnswer: 1,
        scenario: "When approaching your vehicle at night, you should **always have your keys in hand** before leaving a building or entering the parking lot. This eliminates fumbling at the door, which is a prime moment of vulnerability, allows for immediate cabin entry, and keeps your panic button immediately accessible to deter potential threats.",
        explanation: ""
    },
    {
        id: "M2-009",
        moduleId: "module-2",
        category: "Maintenance",
        text: "If the oil pressure warning light comes on, you should ____.",
        options: ["Drive to the nearest shop", "Wait until the next oil change", "Stop immediately and turn off the engine", "Add more water"],
        correctAnswer: 2,
        scenario: "If the oil pressure warning light (the red oil can) comes on, you must **stop immediately and turn off the engine**. This indicates a critical loss of engine lubrication. Running the engine without oil pressure will result in friction welding and complete engine destruction in less than a minute.",
        explanation: ""
    },
    {
        id: "M2-010",
        moduleId: "module-2",
        category: "Awareness",
        text: "A pre-drive walk-around helps identify ____.",
        options: ["Flat tires", "Fluid leaks", "People or objects in the path", "All of the above"],
        correctAnswer: 3,
        scenario: "A thorough pre-drive walk-around allows you to identify **flat tires, fluid leaks, and any people, animals, or objects** hidden in your HTS path of travel. Checking these before starting the engine prevents catastrophic tire blowouts, engine damage from fluid starvation, and tragic back-over accidents.",
        explanation: ""
    },
    {
        id: "M2-011",
        moduleId: "module-2",
        category: "Controls",
        text: "Anti-lock brakes (ABS) allow you to ____ while braking hard.",
        options: ["Stop instantly", "Steer", "Spin", "Accelerate"],
        correctAnswer: 1,
        scenario: "When you apply hard, maximum pressure to the brake pedal in an emergency, the computerized Anti-lock Braking System (ABS) rapidly 'pumps' the brakes hundreds of times per second. This prevents the wheels from locking up and sliding, allowing you to maintain traction and **steer** around hazards while decelerating.",
        explanation: ""
    },
    {
        id: "M2-012",
        moduleId: "module-2",
        category: "Controls",
        text: "Electronic Stability Control (ESC) helps prevent ____.",
        options: ["Speeding", "Loss of traction and skids", "Flat tires", "Engine failure"],
        correctAnswer: 1,
        scenario: "Electronic Stability Control (ESC) monitors sensors hundreds of times per second. If it detects a **loss of traction and skidding** (understeer or oversteer), it automatically applies braking pressure to individual wheels and reduces engine power to bring the vehicle back onto your intended path.",
        explanation: ""
    },
    {
        id: "M2-013",
        moduleId: "module-2",
        category: "Awareness",
        text: "A yellow dashboard light indicates a ____ component.",
        options: ["Critical", "Cautionary/Non-critical fault", "Decorative", "System-active"],
        correctAnswer: 1,
        scenario: "A yellow dashboard light indicates a **cautionary or non-critical fault** that requires attention soon. It is not an immediate emergency, but ignoring a yellow caution light (such as the Check Engine light or low tire pressure TPMS light) will eventually lead to system failure, higher repair costs, or a roadside breakdown.",
        explanation: ""
    },
    {
        id: "M2-014",
        moduleId: "module-2",
        category: "Controls",
        text: "The parking brake should be used ____.",
        options: ["Only on hills", "Every time you park", "Only in emergencies", "When the battery is dead"],
        correctAnswer: 1,
        scenario: "You should engage the parking brake **every time you park** the vehicle, not just when parked on steep hills. Engaging the parking brake mechanically secures the wheels, preventing the vehicle from rolling and protecting the transmission's parking pawl from excessive wear or failure.",
        explanation: ""
    },
    {
        id: "M2-015",
        moduleId: "module-2",
        category: "Controls",
        text: "Internal mirrors should be adjusted to see ____.",
        options: ["The backseat", "The entire rear window", "The driver's face", "Side traffic"],
        correctAnswer: 1,
        scenario: "You should adjust the internal rearview mirror to frame **the entire rear window**. This provides the widest possible view of the traffic directly behind you without requiring you to move your head, helping you maintain continuous situational awareness.",
        explanation: ""
    },
    {
        id: "M2-016",
        moduleId: "module-2",
        category: "Controls",
        text: "The BGE (Blind Spot/Glare Elimination) mirror setting requires ____.",
        options: ["Tilting mirrors way up", "Turning mirrors outward 15 degrees", "Looking at the car door", "No exterior mirrors"],
        correctAnswer: 1,
        scenario: "The BGE method requires **turning your side mirrors outward 15 degrees** (about 1 to 2 turns out) until the sides of your own vehicle are no longer visible. This significantly expands your peripheral view, overlaps with your rearview mirror, and virtually eliminates side blind spots.",
        explanation: ""
    },
    {
        id: "M2-017",
        moduleId: "module-2",
        category: "Safety",
        text: "Airbags deploy at speeds over ____.",
        options: ["100 MPH", "200 MPH", "10 MPH", "50 MPH"],
        correctAnswer: 1,
        scenario: "To protect occupants before they hit the car's interior, airbags deploy in a fraction of a second (about 1/20th of a second) at speeds **over 200 MPH**. Because of this explosive deployment speed, drivers must sit at least 10 inches back from the steering wheel and children under 13 should sit in the rear seat.",
        explanation: ""
    },
    {
        id: "M2-018",
        moduleId: "module-2",
        category: "Awareness",
        text: "Night vision is significantly reduced compared to day vision.",
        options: ["True", "False"],
        correctAnswer: 0,
        scenario: "Night vision is **significantly reduced** compared to daytime. To defend your night vision, you must use the instrument panel dimmer switch to lower dashboard lights. Bright interior gauges cause blinding reflections on the windshield and constrict your pupils, making it much harder to see hazards in the dark.",
        explanation: ""
    },
    {
        id: "M2-019",
        moduleId: "module-2",
        category: "Controls",
        text: "Tilt steering allows the driver to adjust the ____ of the wheel.",
        options: ["Depth", "Height/Angle", "Circumference", "Firmness"],
        correctAnswer: 1,
        scenario: "The tilt steering wheel control allows you to adjust the **height and angle** of the steering wheel. Proper adjustment ensures the steering wheel is pointed toward your chest (never your face or neck) to optimize airbag protection, and keeps your arms in a comfortable, non-fatiguing position.",
        explanation: ""
    },
    {
        id: "M2-020",
        moduleId: "module-2",
        category: "Strategy",
        text: "Visual acuity is the ability to ____.",
        options: ["See motion", "See detail clearly", "See in the dark", "Estimate depth"],
        correctAnswer: 1,
        scenario: "Visual acuity is the driver's ability to **see details clearly**. High visual acuity is essential for reading distance signs, identifying roadway hazards, recognizing pedestrians, and estimating closing speeds in time to make safe decisions.",
        explanation: ""
    },
    {
        id: "M2-021",
        moduleId: "module-2",
        category: "Controls",
        text: "What is the primary function of the vehicle's odometer?",
        options: [
            "To measure current travel velocity",
            "To record the total cumulative distance traveled by the vehicle",
            "To track real-time fuel efficiency",
            "To monitor engine temperature levels"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **The primary function of the odometer is to record the total cumulative distance traveled by the vehicle. The speedometer measures current velocity, while gauges monitor fuel efficiency and engine temperature.**",
        explanation: ""
    },
    {
        id: "M2-022",
        moduleId: "module-2",
        category: "Safety",
        text: "When adjusting the driver's seat, what is the minimum recommended distance between your chest and the steering wheel airbag?",
        options: ["5 inches", "10 inches", "15 inches", "20 inches"],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Airbags deploy with explosive force at speeds exceeding 200 MPH. To prevent chest trauma from the initial expansion wave, maintain a minimum of 10 inches between your chest and the steering wheel hub.**",
        explanation: ""
    },
    {
        id: "M2-023",
        moduleId: "module-2",
        category: "Awareness",
        text: "What is 'fringe vision' primarily used for in defensive driving?",
        options: [
            "Reading small print on street signs",
            "Monitoring vehicle dashboard dials",
            "Tracking path of travel, references, and other cars in the lane",
            "Seeing objects in total darkness"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Fringe vision surrounds your central focal vision and is used to track your path of travel, alignment references, and lane boundaries, helping you notice vehicles drifting into your space.**",
        explanation: ""
    },
    {
        id: "M2-024",
        moduleId: "module-2",
        category: "Controls",
        text: "When executing the BGE mirror adjustment, how should the side-view mirrors be positioned?",
        options: [
            "Turned inward to see the sides of your own car",
            "Turned outward so you only see adjacent lanes and eliminate overlapping blind spots",
            "Tilted upward to see the sky",
            "Tilted downward to watch the tires"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **The BGE (Blind Spot/Glare Elimination) method turns side mirrors outward 15 degrees so you only see adjacent lanes, eliminating overlapping rearview mirror fields and virtually eradicating side blind spots.**",
        explanation: ""
    },
    {
        id: "M2-025",
        moduleId: "module-2",
        category: "Maintenance",
        text: "What does a glowing green or blue indicator light on your dashboard represent?",
        options: [
            "A critical engine failure that requires stopping immediately",
            "A non-critical cautionary warning",
            "An active system or utility is currently in use (e.g. high beams)",
            "An auto-insurance billing alert"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Green or blue dashboard lights represent active systems currently in use (e.g., high beams, headlights, cruise control). Red lights signal critical safety risks or failures, and yellow lights indicate non-critical faults.**",
        explanation: ""
    }
];
